var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{ name: 'Solution', params: { id: _vm.data.id } }}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.data.solution))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }